import React, { useEffect, useMemo, useState } from 'react';
import { NotificationLogClient } from '@atlaskit/notification-log-client';
import { useHelpPanel } from '@atlassian/jira-help-panel-services/src/components/index.tsx';
import { LazyNotifications as Notifications } from './lazy-badge/index.tsx';
import type { BadgeProps } from './types.tsx';

class MockNotificationLogClient extends NotificationLogClient {
	count = 0;

	constructor(countValue: number) {
		super('', '');
		this.count = countValue;
	}

	countUnseenNotifications() {
		return Promise.resolve({ count: this.count });
	}
}

const emptyClient = new MockNotificationLogClient(0);

export const useNotificationLogProvider = async (isNotificationCleared: boolean) => {
	// Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const [{ releaseNotesNotifications }] = useHelpPanel();

	// Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const notificationLogProvider = useMemo(
		() => new MockNotificationLogClient(releaseNotesNotifications),
		[releaseNotesNotifications],
	);

	const result = await Promise.resolve(
		isNotificationCleared || __SERVER__ || releaseNotesNotifications === 0
			? emptyClient
			: notificationLogProvider,
	);

	return result;
};

// Delete on clean up of nav_help_icon_vc90_top_offender_improvements
export const Badge = ({ isNotificationCleared }: BadgeProps) => {
	const [notifications, setNotifications] = useState(0);

	const notificationLogProvider = useNotificationLogProvider(isNotificationCleared);

	useEffect(() => {
		const initNotifications = async () => {
			const result = await notificationLogProvider;
			setNotifications(result.count);
		};

		initNotifications();
	}, [notificationLogProvider]);

	return notifications > 0 ? (
		<Notifications max={3} appearance="primary">
			{notifications}
		</Notifications>
	) : null;
};

// Rename to Badge on clean up of nav_help_icon_vc90_top_offender_improvements
export const BadgeWithoutClient = ({
	releaseNotesNotifications = 0,
}: {
	releaseNotesNotifications: number;
}) => {
	return releaseNotesNotifications > 0 && !__SERVER__ ? (
		<Notifications max={3} appearance="primary">
			{releaseNotesNotifications}
		</Notifications>
	) : null;
};
